import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export function Services() {
  const { t } = useTranslation();

  const services = [
  {
    icon: (
      <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 3.75a2.25 2.25 0 012.25-2.25h2.5a2.25 2.25 0 012.25 2.25v10.5a2.25 2.25 0 01-2.25 2.25h-2.5a2.25 2.25 0 01-2.25-2.25V3.75z" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 10.75h5" />
      </svg>
    ),
    title: t('services.items.sales.title'),
    description: t('services.items.sales.description'),
    features: [
      t('services.items.sales.features[0]'),
      t('services.items.sales.features[1]'),
      t('services.items.sales.features[2]'),
      t('services.items.sales.features[3]'),
      t('services.items.sales.features[4]'),
      t('services.items.sales.features[5]'),
    ],
    cta: t('services.items.sales.cta'),
    href: '/products',
    color: 'green',
  },
  {
    icon: (
      <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
      </svg>
    ),
    title: t('services.items.parts.title'),
    description: t('services.items.parts.description'),
    features: [
      t('services.items.parts.features[0]'),
      t('services.items.parts.features[1]'),
      t('services.items.parts.features[2]'),
      t('services.items.parts.features[3]'),
      t('services.items.parts.features[4]'),
      t('services.items.parts.features[5]'),
    ],
    cta: t('services.items.parts.cta'),
    href: '/parts',
    color: 'blue',
  },
  {
    icon: (
      <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" />
      </svg>
    ),
    title: t('services.items.repair.title'),
    description: t('services.items.repair.description'),
    features: [
      t('services.items.repair.features[0]'),
      t('services.items.repair.features[1]'),
      t('services.items.repair.features[2]'),
      t('services.items.repair.features[3]'),
      t('services.items.repair.features[4]'),
      t('services.items.repair.features[5]'),
    ],
    cta: t('services.items.repair.cta'),
    href: '/service',
    color: 'orange',
  },
  {
    icon: (
      <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
      </svg>
    ),
    title: t('services.items.precision.title'),
    description: t('services.items.precision.description'),
    features: [
      t('services.items.precision.features[0]'),
      t('services.items.precision.features[1]'),
      t('services.items.precision.features[2]'),
      t('services.items.precision.features[3]'),
      t('services.items.precision.features[4]'),
      t('services.items.precision.features[5]'),
    ],
    cta: t('services.items.precision.cta'),
    href: '/precision-ag',
    color: 'purple',
  },
  {
    icon: (
      <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    ),
    title: t('services.items.irrigation.title'),
    description: t('services.items.irrigation.description'),
    features: [
      t('services.items.irrigation.features[0]'),
      t('services.items.irrigation.features[1]'),
      t('services.items.irrigation.features[2]'),
      t('services.items.irrigation.features[3]'),
      t('services.items.irrigation.features[4]'),
      t('services.items.irrigation.features[5]'),
    ],
    cta: t('services.items.irrigation.cta'),
    href: '/irrigation',
    color: 'cyan',
  },
  {
    icon: (
      <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    ),
    title: t('services.items.financing.title'),
    description: t('services.items.financing.description'),
    features: [
      t('services.items.financing.features[0]'),
      t('services.items.financing.features[1]'),
      t('services.items.financing.features[2]'),
      t('services.items.financing.features[3]'),
      t('services.items.financing.features[4]'),
      t('services.items.financing.features[5]'),
    ],
    cta: t('services.items.financing.cta'),
    href: '/financing',
    color: 'emerald',
  },
];

  const serviceProcess = [
  { step: '01', title: t('services.process.consultation.title'), description: t('services.process.consultation.description') },
  { step: '02', title: t('services.process.proposal.title'), description: t('services.process.proposal.description') },
  { step: '03', title: t('services.process.delivery.title'), description: t('services.process.delivery.description') },
  { step: '04', title: t('services.process.support.title'), description: t('services.process.support.description') },
];

  const testimonials = [
    {
      quote: t('services.testimonials.james.quote'),
      author: t('services.testimonials.james.author'),
      role: t('services.testimonials.james.role'),
      avatar: '/images/testimonials/james-mitchell.jpg',
    },
    {
      quote: t('services.testimonials.maria.quote'),
      author: t('services.testimonials.maria.author'),
      role: t('services.testimonials.maria.role'),
      avatar: '/images/testimonials/maria-rodriguez.jpg',
    },
    {
      quote: t('services.testimonials.david.quote'),
      author: t('services.testimonials.david.author'),
      role: t('services.testimonials.david.role'),
      avatar: '/images/testimonials/david-thompson.jpg',
    },
  ];

  return (
    <>
      {/* Page Header */}
      <section className="bg-green-700 text-white py-16 sm:py-24">
        <div className="container-main">
          <div className="max-w-3xl">
            <h1 className="text-4xl sm:text-5xl font-bold mb-4">{t('services.title')}</h1>
            <p className="text-green-100 text-lg">
              {t('services.description')}
            </p>
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="section bg-white">
        <div className="container-main">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service, index) => (
              <article key={index} className="card p-6 sm:p-8 hover:shadow-xl transition-shadow duration-300">
                <div className={`w-16 h-16 bg-${service.color}-100 rounded-xl flex items-center justify-center text-${service.color}-700 mb-6`}>
                  {service.icon}
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-3">{service.title}</h3>
                <p className="text-gray-600 mb-6">{service.description}</p>
                
                <ul className="space-y-3 mb-6" role="list">
                  {service.features.map((feature, i) => (
                    <li key={i} className="flex items-start space-x-3 text-sm text-gray-600">
                      <svg className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                      </svg>
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
                
                <Link 
                  to={service.href} 
                  className={`btn-${service.color} w-full text-center ${service.color === 'orange' ? 'btn-orange' : service.color === 'purple' ? 'btn-purple' : service.color === 'cyan' ? 'btn-cyan' : service.color === 'emerald' ? 'btn-emerald' : ''}`}
                >
                  {service.cta} →
                </Link>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* Service Process */}
      <section className="section bg-gray-50">
        <div className="container-main">
          <div className="text-center max-w-3xl mx-auto mb-16">
            <h2 className="section-title">{t('services.howWeWork')}</h2>
            <p className="section-subtitle">{t('services.howWeWorkSubtitle')}</p>
          </div>
          
          <div className="grid md:grid-cols-4 gap-8">
            {serviceProcess.map((step, index) => (
              <div key={index} className="relative text-center">
                <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-2xl font-bold text-green-700">{step.step}</span>
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">{step.title}</h3>
                <p className="text-gray-600">{step.description}</p>
                {index < serviceProcess.length - 1 && (
                  <div className="absolute top-8 left-1/2 w-full h-0.5 bg-green-200 hidden md:block" />
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="section bg-white">
        <div className="container-main">
          <div className="text-center max-w-3xl mx-auto mb-16">
            <h2 className="section-title">{t('services.testimonialsTitle')}</h2>
            <p className="section-subtitle">{t('services.testimonialsSubtitle')}</p>
          </div>
          
          <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="card p-8">
                <div className="flex space-x-1 mb-4" aria-label="5 star rating">
                  {[1,2,3,4,5].map((star) => (
                    <svg key={star} className="w-5 h-5 text-yellow-400 fill-current" viewBox="0 0 20 20" aria-hidden="true">
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                    </svg>
                  ))}
                </div>
                <p className="text-gray-600 mb-6 italic">"{testimonial.quote}"</p>
                <div className="flex items-center space-x-4">
                  <div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center text-gray-400 overflow-hidden">
                    <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                    </svg>
                  </div>
                  <div>
                    <p className="font-semibold text-gray-900">{testimonial.author}</p>
                    <p className="text-sm text-gray-500">{testimonial.role}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Service Areas */}
      <section className="section bg-green-700">
        <div className="container-main">
          <div className="text-center max-w-3xl mx-auto mb-12">
            <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">{t('services.coverageTitle')}</h2>
            <p className="text-green-100 text-lg">{t('services.coverageSubtitle')}</p>
          </div>
          
          <div className="grid md:grid-cols-3 gap-8">
            {[
              {
                title: t('services.locations.headquarters.title'),
                address: t('services.locations.headquarters.address'),
                services: t('services.locations.headquarters.services'),
                hours: t('services.locations.headquarters.hours'),
              },
              {
                title: t('services.locations.north.title'),
                address: t('services.locations.north.address'),
                services: t('services.locations.north.services'),
                hours: t('services.locations.north.hours'),
              },
              {
                title: t('services.locations.south.title'),
                address: t('services.locations.south.address'),
                services: t('services.locations.south.services'),
                hours: t('services.locations.south.hours'),
              },
            ].map((location, index) => (
              <div key={index} className="card bg-green-800 p-6">
                <h3 className="text-xl font-bold text-white mb-3">{location.title}</h3>
                <p className="text-green-200 mb-2">{location.address}</p>
                <p className="text-green-300 text-sm mb-4">{location.services}</p>
                <p className="text-green-100 text-sm">{location.hours}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="section bg-gray-900">
        <div className="container-main text-center">
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">{t('services.ctaTitle')}</h2>
          <p className="text-gray-300 text-lg mb-8 max-w-2xl mx-auto">
            {t('services.ctaDescription')}
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link to="/contact" className="btn-primary text-lg px-8 py-4">
              {t('services.contactUs')}
            </Link>
            <Link to="/service" className="btn border-2 border-gray-600 text-white hover:bg-gray-800 text-lg px-8 py-4">
              {t('services.scheduleService')}
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}

// Additional button styles needed in CSS
// btn-orange, btn-purple, btn-cyan, btn-emerald